/**
 * Edit contact details
 */
$(document).ready(function() {
    $('#TotemForm_EditAffiliateDocumentForm_NotifyStream').on('change', function() {
        if ($(this).is(':checked')) {
            $('#TotemAffiliateCustomersToSendTo').show();
            $('#TotemAffiliateStaffToSendTo').show();
            $('#TotemAffiliateStaffSalesToSendTo').show();
        } else {
            $('#TotemAffiliateCustomersToSendTo').hide();
            $('#TotemAffiliateStaffToSendTo').hide();
            $('#TotemAffiliateStaffSalesToSendTo').hide();
        }
    });
    setTimeout(function() {
        $('#TotemForm_EditAffiliateDocumentForm_NotifyStream').trigger('change');
    }, 1);
});
